<template>
  <section class="my-5 py-5">
    <v-data-table
      class="elevation-3 px-3 datatable-materials"
      v-model="materialsSelected"
      :headers="tableHeaders"
      :items="materials"
      :items-per-page="20"
      item-key="id"
      show-select
      no-data-text="Sin materiales"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 20, 100, -1],
      }"
      :item-class="getRowClass"
      :custom-sort="customSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <small class="font-weight-bold">
              {{ title }}
            </small>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-3"
            :dark="false"
            size="small"
            class="mx-3"
            :disabled="
              !materialsSelected.length ||
                (currentCubage && currentCubage.isClosed)
            "
            @click="openModalDeleteMultipleMaterials"
          >
            <span class="text-white"> Eliminar materiales </span>
          </v-btn>
          <v-btn
            color="blue darken-3"
            :dark="false"
            size="small"
            @click="openModalAddMaterials"
            :disabled="currentCubage && currentCubage.isClosed"
          >
            <span class="text-white"> Agregar Material </span>
          </v-btn>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Estás seguro de eliminar el material?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-3" text>Cancelar</v-btn>
                <v-btn color="red darken-1" @click="dialogDelete = false" text
                  >Eliminar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.material.active="{ item }">
        <v-icon color="success" v-if="item.material && item.material.active">
          mdi-check-circle-outline
        </v-icon>
        <v-icon color="error" v-else>
          mdi-close-circle-outline
        </v-icon>
      </template>
      <template v-slot:item.material="{ item }">
        <v-icon color="primary" v-if="isFavorite(item)">
          mdi-check-circle-outline
        </v-icon>
        <span v-else></span>
      </template>

      <template v-slot:item.document_erp="{ item }">
        <span class="text-datatable-materials">{{
          item.solicitud_erp ? item.solicitud_erp : "-"
        }}</span>
      </template>
      <template v-slot:item.description="{ item }">
        <p class="text-datatable-materials my-0 mt-1 text-left">
          {{ item.material.description }}
        </p>
      </template>
      <template v-slot:item.erp_status="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="text-datatable-materials">{{
              item.erp_status ? (item.erp_status == "OC" ? "SC" : "ST") : "-"
            }}</span>
          </template>
          <span>
            {{
              item.erp_status
                ? item.erp_status == "OC"
                  ? "Solicitud de compra"
                  : "Solicitud de traslado"
                : "-"
            }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.code="{ item }">
        <span class="text-datatable-materials">{{ item.material.code }}</span>
      </template>
      <template v-slot:item.units="{ item }">
        <span class="text-datatable-materials">{{
          item.material.measurement.units
        }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-items-center justify-content-center">
          <v-tooltip top v-if="item.material.code === '-'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                @click="openModalReplaceMaterialWithoutCode(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-find-replace </v-icon>
              </v-btn>
            </template>
            <span>Cambiar a codificado</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :color="item.comments.length ? 'primary' : 'secondary'"
                @click="showCommentsDocumentMaterial(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-message </v-icon>
              </v-btn>
            </template>
            <span>Comentarios</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="currentCubage && currentCubage.isClosed"
                icon
                color="error"
                @click="deleteItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.quantity="{ item }">
        <v-text-field
          v-if="
            (currentCubage && !currentCubage.isClosed) ||
              item.material.code === '-'
          "
          @focusout="updateDocumentMaterial($event, item, 'quantity')"
          class="pt-0 mt-0"
          single-line
          :value="item.quantity"
          :min="1"
          type="number"
          hide-details
        ></v-text-field>
        <span v-else>
          {{ item.quantity }}
        </span>
      </template>
      <template v-slot:item.dispatch="{ item }">
        <v-select
          v-if="
            (currentCubage && !currentCubage.isClosed) ||
              item.material.code === '-'
          "
          :items="dispatchsWrapped"
          :value="item.dispatch.description"
          class="pt-0 mt-0"
          hide-details
          @change="updateDocumentMaterial($event, item, 'dispatch')"
        ></v-select>
        <span v-else>
          {{ item.dispatch.description }}
        </span>
      </template>
      <template v-slot:item.unit_cost="{ item }">
        <v-text-field
          type="number"
          :min="0"
          v-if="
            item.material.code == '-' &&
              !isNaN(item.material.unit_cost) &&
              currentCubage &&
              !currentCubage.isClosed
          "
          @focusout="updateDocumentMaterial($event, item, 'cost')"
          class="pt-0 mt-0"
          hide-details
          :value="item.material.unit_cost"
        ></v-text-field>
        <span v-else>{{
          item.material && item.material.unit_cost
            ? `$ ${new Intl.NumberFormat("de-DE").format(
                parseInt(item.material.unit_cost)
              )}`
            : `$ ${0}`
        }}</span>
      </template>
      <template v-slot:item.total_cost="{ item }">
        <span>{{
          item.material && item.material.unit_cost && item.quantity
            ? `$ ${new Intl.NumberFormat("de-DE").format(
                parseInt(item.total_cost)
              )}`
            : `$ ${0}`
        }}</span>
      </template>
      <template v-slot:footer.prepend>
        <span class="ml-auto mr-5 text-datatable-materials font-weight-bold">
          Total:
          {{
            `$ ${new Intl.NumberFormat("de-DE").format(
              parseInt(getTotalMaterials)
            )}`
          }}
        </span>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    materials: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      debounce: null,
      debounceTime: 200,
      dialog: false,
      dialogDelete: false,
      form: {
        quantity: "",
      },
      materialsSelected: [],
      tableHeaders: [
        {
          text: "Estatus",
          align: "center",
          sortable: true,
          width: "5%",
          value: "material.active",
        },
        {
          text: "STD",
          align: "center",
          sortable: true,
          width: "5%",
          value: "material",
        },
        {
          text: "Código",
          align: "center",
          sortable: true,
          width: "5%",
          value: "code",
        },
        {
          text: this.$route.query.sap_project ? "Código SAP" : "Código SLI",
          align: "center",
          sortable: true,
          width: "5%",
          value: "document_erp",
        },
        {
          text: "Tipo Solicitud",
          align: "center",
          sortable: true,
          width: "5%",
          value: "erp_status",
        },
        {
          text: "Descripción",
          align: "center",
          width: "30%",
          sortable: true,
          value: "description",
        },
        {
          text: "Stock disponible",
          align: "center",
          width: "10%",
          sortable: true,
          value: "available_stock",
        },
        {
          text: "Unidad",
          align: "center",
          width: "5%",
          sortable: true,
          value: "units",
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: true,
          width: "10%",
          value: "quantity",
        },
        {
          text: "Monto unitario",
          align: "center",
          width: "10%",
          sortable: true,
          value: "unit_cost",
        },
        {
          text: "Monto Total",
          align: "center",
          width: "10%",
          sortable: true,
          value: "total_cost",
        },
        {
          text: "Despacho",
          align: "center",
          sortable: true,
          width: "15%",
          value: "dispatch",
        },
        {
          text: "Acciones",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      sendUpdateDocumentMaterial: "cubage/updateDocumentMaterial",
    }),
    openModalAddMaterials() {
      this.$emit("openModalAddMaterials", { type: this.type });
    },
    openModalDeleteMultipleMaterials() {
      this.$emit("openModalDeleteMultipleMaterials", {
        materials: this.materialsSelected.map((item) => item.id),
      });
    },
    openModalReplaceMaterialWithoutCode(item) {
      this.$emit("openModalReplaceMaterial", item);
    },
    showCommentsDocumentMaterial(item) {
      this.$emit("openModalShowCommentsDocumentMaterial", { document: item });
    },
    deleteItem({ id, material }) {
      this.$emit("deleteMaterial", { id, name: material.description });
    },
    async updateDocumentMaterial(event, item, field) {
      let value = event.target ? event.target.value : event;
      if (value) {
        clearTimeout(this.debounce);
        let self = this;
        this.debounce = setTimeout(async function() {
          let payload = {
            id: item.id,
            created_at: item.created_at,
            created_by: self.user.email,
            dispatch: field === "dispatch" ? value : item.dispatch.description,
            quantity:
              field === "quantity"
                ? value >= 1
                  ? Math.trunc(value)
                  : 1
                : item.quantity,
            status: true,
            cost:
              field === "cost"
                ? value
                : item.material.unit_cost
                ? item.material.unit_cost
                : 0,
          };
          const { data } = await self.sendUpdateDocumentMaterial(payload);
          self.$emit("updateValuesDocumentMaterial", {
            ...payload,
            newId: data ? data.id : null,
          });
        }, this.debounceTime);
      }
    },
    isFavorite(item) {
      item = item.material;
      return (
        item.favorite ||
        item.favorite_ci ||
        item.favorite_otros ||
        item.favorite_pg ||
        item.favorite_re
      );
    },
    getRowClass(item) {
      return item.material && item.material.active
        ? "bg-success-opacity"
        : "bg-danger-opacity";
    },
    customSort(items, sortBy, sortDesc, locale) {
      if (!sortBy.length) return items;

      const field = sortBy[0]; // campo actual para ordenar

      if (field === "material.active") {
        return items.sort((a, b) => {
          const diff = a.material.active - b.material.active;
          return sortDesc[0] ? -diff : diff;
        });
      }
      if (field === "material") {
        return items.sort((a, b) => {
          const diff = this.isFavorite(a) - this.isFavorite(b);
          return sortDesc[0] ? -diff : diff;
        });
      }
      if (field === "code") {
        return items.sort((a, b) => {
          const diff = a.material.code.localeCompare(b.material.code);
          return sortDesc[0] ? -diff : diff;
        });
      }

      if (field === "document_erp") {
        return items.sort((a, b) => {
          if (
            a.solicitud_erp === null ||
            a.solicitud_erp === "" ||
            b.solicitud_erp === null ||
            b.solicitud_erp === ""
          ) {
            return 0;
          }
          const diff = a.solicitud_erp.localeCompare(b.solicitud_erp);
          return sortDesc[0] ? -diff : diff;
        });
      }

      if (field === "erp_status") {
        return items.sort((a, b) => {
          if (
            a.erp_status === null ||
            a.erp_status === "" ||
            b.erp_status === null ||
            b.erp_status === ""
          ) {
            return 0;
          }
          const diff = a.erp_status.localeCompare(b.erp_status);
          return sortDesc[0] ? -diff : diff;
        });
      }

      if (field === "description") {
        return items.sort((a, b) => {
          const diff = a.material.description.localeCompare(
            b.material.description
          );
          return sortDesc[0] ? -diff : diff;
        });
      }

      if (field === "available_stock") {
        return items.sort((a, b) => {
          const diff = a.available_stock - b.available_stock;
          return sortDesc[0] ? -diff : diff;
        });
      }

      if (field === "units") {
        return items.sort((a, b) => {
          const diff = a.material.measurement.units.localeCompare(
            b.material.measurement.units
          );
          return sortDesc[0] ? -diff : diff;
        });
      }
      if (field === "quantity") {
        return items.sort((a, b) => {
          const diff = a.quantity - b.quantity;
          return sortDesc[0] ? -diff : diff;
        });
      }
      if (field === "unit_cost") {
        return items.sort((a, b) => {
          const diff = a.material.unit_cost - b.material.unit_cost;
          return sortDesc[0] ? -diff : diff;
        });
      }
      if (field === "total_cost") {
        return items.sort((a, b) => {
          const diff = a.total_cost - b.total_cost;
          return sortDesc[0] ? -diff : diff;
        });
      }
      if (field === "dispatch") {
        return items.sort((a, b) => {
          const diff = a.dispatch.description.localeCompare(
            b.dispatch.description
          );
          return sortDesc[0] ? -diff : diff;
        });
      }
      // Si no se definió un ordenamiento personalizado para el campo, regresamos items sin modificar
      return items;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      currentCubage: "cubage/currentCubage",
      dispatchs: "cubage/dispatchs",
    }),
    getTotalMaterials() {
      return this.materials.reduce(
        (total, item) => (total += item.total_cost),
        0
      );
    },
    dispatchsWrapped() {
      if (this.dispatchs.length) {
        return this.dispatchs.map((item) => item.description);
      }
      return [];
    },
  },
  watch: {
    materials(newMaterials) {
      this.materialsSelected = [];
    },
  },
};
</script>

<style>
.datatable-materials .v-data-footer__select {
  margin-left: 10px;
}

.datatable-materials .v-data-footer {
  display: flex;
  flex-direction: row-reverse;
}

.text-datatable-materials {
  font-size: 12.5px;
}

/* Aplica un color verde casi inperceptible visualmente, negro no */
.bg-success-opacity {
  background-color: rgba(0, 255, 0, 0.06);
}

.bg-danger-opacity {
  background-color: rgba(255, 0, 0, 0.07);
}
</style>
